import { InfoOutlined } from '@mui/icons-material';
import Typography, { TypographyProps } from '@mui/material/Typography';
import { styled } from '@mui/material/styles';

const StyledTooltipText = styled(Typography)(() => ({
  textDecoration: 'underline',
  textDecorationStyle: 'dotted',
}));

type Props = {
  content: React.ReactNode;
  icon?: boolean;
  inline?: boolean;
} & TypographyProps;

const TooltipTriggerText: React.FC<Props> = ({
  content,
  icon,
  children,
  ...props
}) => {
  return (
    <StyledTooltipText {...props}>
      {content} {icon ? <InfoOutlined fontSize="small" /> : null}
    </StyledTooltipText>
  );
};

export default TooltipTriggerText;
